import React, { Component } from "react";
import { Link } from "react-router-dom";
import { logger } from "../../../util/logger";
import { post } from "../../../util/axiosLib";

// components
import Sidemenu from "../../../components/sidemenu";
import Header from "../../../components/dashHeader";

//assets
import Cancel from "../../../assets/svg/other/cancel.svg";
import Arrow from "../../../assets/svg/icons-new/arrow.svg";
import Check from "../../../assets/svg/icons-new/check.svg";
// import User from '../../../assets/svg/icons-new/user.png'
import Load from "../../../assets/svg/other/loading2.svg";
import User from "../../../assets/profile.svg";
import Edit from "../../../assets/svg/icons-new/edit.svg";
import Bank from "../../../assets/svg/icons-new/banks.svg";
import Bvn from "../../../assets/svg/icons-new/bvn.svg";
import Refer from "../../../assets/svg/icons-new/refer.svg";
//import Support from '../../../assets/svg/icons-new/support.svg'
import Logout from "../../../assets/svg/icons-new/logout.svg";
import SupportBox from "../../../components/support";

import VerificationIcon from "../../../assets/svg/verification.svg";

import Back from "../../../assets/svg/back-arrow.svg";

//css
import "../../styles/dashboard/Account.css";

export default class AccountBVN extends Component {
  state = {
    unVerifiedShow: true,
    userData: "",
  };

  // handleBank = event => {
  //     event.preventDefault();

  //     this.setState({
  //         bankSection: true,
  //         cardSection: false,
  //     })
  // }
  // handleCard = event => {
  //     event.preventDefault();

  //     this.setState({
  //         bankSection: false,
  //         cardSection: true,
  //         changePassword: false
  //     })
  // }
  // handleCP = event => {
  //     event.preventDefault();

  //     this.setState({
  //         bankSection: false,
  //         cardSection: false,
  //         changePassword: true
  //     })
  // }

  componentDidMount() {
    // const token = localStorage.getItem("tokenset");
    const userData = JSON.parse(localStorage.getItem("btm_user"));
    localStorage.setItem("changePinStatus", false);

    this.setState({
      userData,
    });
  }

  addBVN = async (event) => {
    event.preventDefault();
    try {
      // load gif
      const loaded = document.getElementById("load");
      loaded.classList.add("load-gif-on2");

      this.setState({ successMsg: " " });

      const token = localStorage.getItem("tokenset");

      const headers = {
        "Content-Type": "application/json",
        authorization: `${token}`,
      };

      const bvnDetails = {
        bvn: this.state.bvn,
        countryCode: "ng",
      };

      const addBvnReq = await post(
        `${process.env.REACT_APP_API_ENDPOINT}/verification/bvn`,
        bvnDetails,
        headers
      );

      logger(addBvnReq);

      this.setState({ successMsg: "Bvn added" });

      //    setTimeout(() => {
      //       window.location.reload()
      //   }, 2500);

      //const loaded = document.getElementById("load");
      loaded.classList.remove("load-gif-on2");
    } catch (err) {
      logger(err);
      const loaded = document.getElementById("load");
      loaded.classList.remove("load-gif-on2");
      this.setState({ incorrectError: err.data });
      if (err.isAxiosError) {
        //const errData = err.response;

        const loaded = document.getElementById("load");
        loaded.classList.remove("load-gif-on");

        //this.setState({ incorrectError: errData.data.error });
      }
    }
  };

  render() {
    const currentPage = "Account";

    return (
      <div>
        <Sidemenu currentPage={currentPage} />
        <Header />
        <section>
          <div className="account-container">
            {this.state.unVerifiedShow ? (
              <div className="home-verifywarn-m">
                <p className="h-v-m"> You need to verify your account </p>
                <Link to="/dashboard/accountverify" className="verify-m h-v-m">
                  <p>Verify now</p>
                </Link>
              </div>
            ) : null}
            <Link to="/dashboard/account">
              <img src={Back} className="w-backarrow" alt="back" />
            </Link>
            <div className="account-content">
              <div className="account-top">
                <h1 className="b-header"> Account </h1>
                {/* <h1 className="m-header"> BVN </h1> */}
                {this.state.unVerifiedShow ? (
                  <div className="home-verifywarn">
                    <p className="h-v-m">
                      {" "}
                      Verify your account now to start buying, selling, sending
                      and receiving cryptocurrencies.{" "}
                    </p>
                    <Link
                      to="/dashboard/accountverify"
                      className="verify-link h-v-m"
                    >
                      Verify <span>now</span>
                    </Link>
                    <img
                      onClick={() => this.setState({ unVerifiedShow: false })}
                      src={Cancel}
                      alt="cancel"
                    />
                  </div>
                ) : null}
              </div>
              <div className="account-nav animate__animated animate__fadeInDown">
                <Link to="/dashboard/account" className="right-e">
                  <p className="ash"> Account </p>{" "}
                </Link>
                <img className="right-e" src={Arrow} alt="" />
                <p>
                  <span className="bold"> BVN </span>
                </p>
              </div>
              <div className="account-sections">
                <div className="account-section-left section-hide">
                  <div className="asl-content">
                    <div className="asl-profile-box">
                      <div className="asl-profile-img">
                        <img className="right-m1" src={User} alt="user" />
                      </div>
                      <div className="asl-profile-info">
                        <h2>
                          {this.state.userData.firstName +
                            " " +
                            this.state.userData.lastName}{" "}
                        </h2>
                        {this.state.userData.twoFactor ? (
                          <p className="asl-verified-txt">
                            <span className="right-m1">
                              <img src={Check} alt="check" />
                            </span>
                            Verified
                          </p>
                        ) : (
                          <p>Unverified</p>
                        )}
                      </div>
                    </div>
                    <div className="asl-actions">
                      <Link
                        to="/dashboard/accountedit"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Edit} alt="edit" />
                          <p>Edit Profile </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link>
                      <Link
                        to="/dashboard/accountbanks"
                        className="asl-action-single "
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Bank} alt="edit" />
                          <p>Banks and Cards </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link>
                      <Link
                        to="/dashboard/accountVerification"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img
                            className="right-m2"
                            src={VerificationIcon}
                            alt="edit"
                          />
                          <p>Verification</p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link>
                      <Link
                        to="/dashboard/accountbvn"
                        className="asl-action-single asl-active"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Bvn} alt="edit" />
                          <p> BVN </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link>
                      <Link
                        to="/dashboard/accountrefer"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Refer} alt="edit" />
                          <p>Refer a friend </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link>
                      <SupportBox />
                      <Link to="/" className="asl-action-single">
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Logout} alt="edit" />
                          <p>Log out </p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="account-section-right animate__animated animate__fadeIn">
                  <div className="asr-edit">
                    <h2> BVN </h2>

                    <form className="asr-edit-form" onSubmit={this.addBVN}>
                      <p> Kindly provide your BVN digits </p>
                      <div className="asr-edit-input">
                        <input
                          type="text"
                          placeholder="BVN"
                          onChange={(e) =>
                            this.setState({ bvn: e.target.value })
                          }
                          required
                        />
                      </div>
                      <div className="asr-edit-input">
                        <button className="asr-edit-btn" type="submit">
                          {" "}
                          Save Changes{" "}
                        </button>
                      </div>
                      <div className="load-gif2" id="load">
                        <img src={Load} alt="loading" />
                      </div>
                      <p className="successmsg2" id="successmsg">
                        {this.state.successMsg}
                      </p>
                      <p className="errormsg3" id="errormsg">
                        {this.state.incorrectError}
                      </p>
                      <p className="errormsg3">{this.state.otherError}</p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
